import Raven from 'raven-js';
export const errorMiddleware = () => next => action => {
  Raven.captureBreadcrumb({
    message: action.type,
    category: 'redux action'
  });
  return next(action);
};